export enum PermissionScopes {
	Users = 'users',
	Roles = 'roles',
	Report = 'report',
	Customers = 'customers',
	CustomerContractPayment = 'customerContractPayment',
	CustomerRetentionRates = 'customerRetentionRates',
	CustomerNotes = 'customerNotes',
	CustomerRebateGroups = 'customerRebateGroups',
	CustomerMonthlyData = 'customerMonthlyData',
	CustomerCustomDateOfService = 'customerCustomDateOfService',
	MarkCustomerMonthlySubmissionAsReady = 'markCustomerMonthlySubmissionAsReady',
	CustomerThirdPartyAssociation = 'customerThirdPartyAssociation',
	CustomerBdc = 'customerBdc',
	Storage = 'storage',
	Audit = 'auditLog',
	DataLoadingHistory = 'dataLoadingStatistic',
	Claim = 'receipt',
	DealerGroups = 'dealerGroups',
	ReinsuranceAgreements = 'reinsuranceAgreements',
	Hangfire = 'hangfire',
	LoadedDealerData = 'loadedDealerData',
	ApproveLoadedDealerData = 'approveLoadedDealerData',
	Ndc = 'ndc',
	FormularyNdc = 'formularyNdc',
	RebateAggregators = 'rebateAggregators',
	RebateAggregatorFormularies = 'rebateAggregatorFormularies',
	RebatesLoad = 'rebatesLoad',
	RebatesLoadExtraDelete = 'rebatesLoadExtraDelete',
	RebatesLoadChangeSubmissionPeriod = 'rebatesLoadChangeSubmissionPeriod',
	RebatesUpdate = 'rebatesUpdate',
	RebatesReSubmission = 'rebatesReSubmission',
	Payor = 'payor',
	LineOfBusiness = 'lineOfBusiness',
	LineOfBusinessSubtype = 'lineOfBusinessSubtype',
	ThirdParty = 'thirdParty',
	RebateLoadRevalidateFileRecords = 'rebateLoadRevalidateFileRecords',
	NdcReplacementMappings = 'ndcReplacementMappings',
	DownstreamClientIdAssociation = 'downstreamClientIdAssociation',
	SubmissionPeriod = 'submissionPeriod',
	RebateAggregatorNdcRates = 'rebateAggregatorNdcRates',
	AberrantQuantity = 'aberrantQuantity',
	UnbreakableQuantity = 'unbreakableQuantity',
	RebateGroup = 'rebateGroup',
	ExcludedPharmacy = 'excludedPharmacy',
	InOutpatientDefinition = 'inOutpatientDefinition',
	NonPatientExclusion = 'nonPatientExclusion',
	AuditEvents = 'auditEvents',
	RebateLoadRollbackFile = 'rebateLoadRollbackFile',
	ProcessingConfig = 'processingConfig',
	RebateGroupAggregatorNdc = 'rebateGroupAggregatorNdc',
	CustomerNdcDestination = 'customerNdcDestinations',
	SubmissionOverview = 'submissionOverview',
	SubmissionFiles = 'submissionFiles',
	RebateLoadAiMapping = 'rebateLoadAIMapping',
	RebateLoadAiConversion = 'rebateLoadAIConversion'
}
